// extracted by mini-css-extract-plugin
export default {"checkBox":"styles_checkBox__cwB8O","details":"styles_details__X4CzZ","row":"styles_row__DK2aR","dot":"styles_dot__6SdWm"};